var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowBackCircle24Fill = function SvgIconArrowBackCircle24Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.65c-4.605 0-8.35 3.745-8.35 8.35 0 4.605 3.745 8.35 8.35 8.35 4.605 0 8.35-3.745 8.35-8.35 0-4.605-3.745-8.35-8.35-8.35Zm3.75 9.2h-4.795l2.095 1.995-1.175 1.23L8.7 13.05A1.456 1.456 0 0 1 8.25 12c0-.395.165-.78.45-1.05l3.175-3.025 1.175 1.23-2.095 1.995h4.795v1.7Z"
  })));
};
export default SvgIconArrowBackCircle24Fill;